module.exports = __webpack_public_path__ + "static/media/logo-avatar.d424a395.svg";